import { render, staticRenderFns } from "./DisplayIcon.vue?vue&type=template&id=604c62c1&scoped=true&"
import script from "./DisplayIcon.vue?vue&type=script&lang=ts&"
export * from "./DisplayIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayIcon.vue?vue&type=style&index=0&id=604c62c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c62c1",
  null
  
)

export default component.exports